import { Code, Badge, Table } from "@mantine/core";

function LogLevelBadge({ level }) {
  switch (level) {
    case "error":
      return (
        <Badge variant="light" color="red">
          Error
        </Badge>
      );
    case "warn":
      return (
        <Badge variant="light" color="yellow">
          Warning
        </Badge>
      );
    case "info":
      return (
        <Badge variant="light" color="blue">
          Info
        </Badge>
      );
    default:
      return (
        <Badge variant="light" color="gray">
          {level}
        </Badge>
      );
  }
}

function JobLogs({ logs }) {
  return (
    <Table mt="xs">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Timestamp</Table.Th>
          <Table.Th>Level</Table.Th>
          <Table.Th>Message</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {logs.map((msg) => (
          <Table.Tr key={msg.id}>
            <Table.Td style={{ verticalAlign: "top", minWidth: "200px" }}>
              {msg.idCreated}
            </Table.Td>
            <Table.Td style={{ verticalAlign: "top", minWidth: "80px" }}>
              <LogLevelBadge level={msg.severity} />
            </Table.Td>
            <Table.Td>
              <Code style={{ textWrap: "auto" }} block>
                {msg.message}
              </Code>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}

export default JobLogs;
